import Vue from 'vue'
import { userFetch, articleFetch } from '@/api'

// 认证 / 封禁类错误已由 request.js 的拦截器统一处理（弹登录框、封禁弹窗），
// 业务层再 toast 一次会出现「两个提示叠在一起」
const SILENT_ERRORS = ['__SILENT_AUTH__', '__ACCOUNT_BANNED__']

function isSilentError (err) {
  return SILENT_ERRORS.includes(err?.message)
}

export default {
  data () {
    return {}
  },
  methods: {
    // 格式化数量
    formatViews (views) {
      if (!views || views === 0) return '0'
      if (views >= 100000000) {
        return (views / 100000000).toFixed(1) + '亿'
      } else if (views >= 10000) {
        return (views / 10000).toFixed(1) + 'w'
      } else if (views >= 1000) {
        return (views / 1000).toFixed(1) + 'k'
      }
      return views.toString()
    },

    /**
     * 点赞 / 取消点赞
     *
     * 先改 UI 再发请求（乐观更新），但必须满足两点，否则数据会和服务端长期不一致：
     * 1. 请求失败要把计数和状态回滚；
     * 2. 请求期间禁止重复点击 —— 连点会连发请求，服务端按「切换」处理，
     *    最终状态取决于响应顺序，界面很容易和实际点赞状态相反。
     */
    like (article) {
      if (!article || article._likePending) return
      const { id: articleId, isLike } = article
      const prevCount = article.likeCount

      // 纯粹的请求锁，不需要参与响应式（避免多余的重渲染）
      article._likePending = true
      Vue.set(article, 'isLike', !isLike)
      Vue.set(article, 'likeCount', Math.max((prevCount || 0) + (isLike ? -1 : 1), 0))
      this.onArticleChange?.(article)

      return articleFetch.articleLike({
        articleId,
        type: article.type,
        articleUserId: article.userInfoVO?.id,
      }).then(() => {
        this.$toast.success(isLike ? '取消点赞' : '点赞成功')
      }).catch(err => {
        // 回滚，避免界面显示已点赞、刷新后又变回未点赞
        Vue.set(article, 'isLike', isLike)
        Vue.set(article, 'likeCount', prevCount)
        if (!isSilentError(err)) {
          this.$toast.error(err?.message || '操作失败')
        }
        this.onArticleChange?.(article)
      }).finally(() => {
        article._likePending = false
      })
    },

    // 收藏 / 取消收藏（同样需要失败回滚 + 防重复点击）
    async handleCollect (article) {
      if (!article || article._collectPending) return
      const { isCollect, collectCount } = article
      const params = {
        articleId: article.id,
        type: article.type,        // '0'：帖子  '1': 同校
        articleUserId: article.userInfoVO?.id,
      }

      article._collectPending = true
      Vue.set(article, 'isCollect', !isCollect)
      Vue.set(article, 'collectCount', Math.max((collectCount || 0) + (isCollect ? -1 : 1), 0))
      this.onArticleChange?.(article)

      try {
        isCollect
          ? await userFetch.cancelCollect(params)
          : await userFetch.postCollect(params)
        this.$toast.success(isCollect ? '已取消' : '收藏成功')
        this.collectCallback?.()
      } catch (err) {
        Vue.set(article, 'isCollect', isCollect)
        Vue.set(article, 'collectCount', collectCount)
        if (!isSilentError(err)) {
          this.$toast.error(err?.message || '操作失败')
        }
        this.onArticleChange?.(article)
      } finally {
        article._collectPending = false
      }
    },
  }
}
